import { api } from '../../lib/api';

export interface ResidentRow {
  id: string;
  code: string;
  householdId: string | null;
  household: { id: string; code: string; purok: string; houseNo: string; street: string } | null;
  relationship: string;
  lastName: string;
  firstName: string;
  middleName: string;
  suffix: string;
  displayName: string;
  sex: 'MALE' | 'FEMALE';
  birthDate: string;
  age: number;
  birthPlace: string;
  civilStatus: string;
  citizenship: string;
  occupation: string;
  religion: string;
  contactNumber: string;
  email: string;
  philsys: string | null;
  photoFileId: string | null;
  sectors: string[];
  storedSectors: string[];
  residentSince: string | null;
  status: 'ACTIVE' | 'TRANSFERRED_OUT' | 'DECEASED' | 'MERGED';
  statusDate: string | null;
  statusReason: string;
  lawfulBasis: string;
  consentDate: string | null;
  noticeVersion: string;
  consentFileId: string | null;
  importSource: string | null;
  readOnly: boolean;
}

export interface ResidentDetail extends ResidentRow {
  events: { id: string; kind: string; date: string; reason: string; before: Record<string, unknown> | null; after: Record<string, unknown> | null; createdAt: string }[];
  idCards: { id: string; cardNo: string; issuedAt: string; validUntil: string; revokedAt: string | null; revokedReason: string; token: string | null }[];
  householdMembers: { id: string; code: string; displayName: string; relationship: string; age: number; status: string }[];
  mergedInto: { id: string; code: string } | null;
}

export interface DuplicateMatch { id: string; code: string; displayName: string; birthDate: string; status: string; household: string | null; reason: string }

export const SECTOR_LABELS: Record<string, string> = {
  SENIOR_CITIZEN: 'Senior citizen', YOUTH: 'Youth (15–30)', MINOR: 'Minor', PWD: 'PWD', SOLO_PARENT: 'Solo parent', '4PS': '4Ps',
  IP: 'Indigenous people', OFW: 'OFW', OSY: 'Out-of-school youth', PREGNANT_LACTATING: 'Pregnant / lactating', REGISTERED_VOTER: 'Registered voter',
};
export const sectorLabel = (s: string) => SECTOR_LABELS[s] ?? s.replace(/_/g, ' ').toLowerCase().replace(/^\w/, (m) => m.toUpperCase());

export const CIVIL: Record<string, string> = { SINGLE: 'Single', MARRIED: 'Married', WIDOWED: 'Widowed', SEPARATED: 'Separated', ANNULLED: 'Annulled', LIVE_IN: 'Live-in' };
export const RELATIONSHIPS = ['HEAD', 'SPOUSE', 'PARTNER', 'SON', 'DAUGHTER', 'STEPCHILD', 'SON_IN_LAW', 'DAUGHTER_IN_LAW', 'GRANDCHILD', 'FATHER', 'MOTHER', 'SIBLING', 'NEPHEW_NIECE', 'OTHER_RELATIVE', 'HELPER', 'BOARDER', 'OTHER'];
export const relLabel = (r: string) => (r ? r.replace(/_/g, ' ').toLowerCase().replace(/^\w/, (m) => m.toUpperCase()) : '—');
export const LAWFUL: Record<string, string> = {
  CONSENT: 'Consent of the resident',
  LEGAL_OBLIGATION: 'Legal obligation (the barangay must keep the RBI)',
  PUBLIC_TASK: 'Public task / mandate of the barangay',
  VITAL_INTEREST: 'Vital interest (emergency)',
};
export const STATUS: Record<string, { label: string; tone: 'ok' | 'neutral' | 'warning' | 'critical' | 'info' }> = {
  ACTIVE: { label: 'Active', tone: 'ok' }, TRANSFERRED_OUT: { label: 'Transferred out', tone: 'neutral' }, DECEASED: { label: 'Deceased', tone: 'neutral' }, MERGED: { label: 'Merged', tone: 'warning' },
};

export interface BarangaySettings { puroks: string[]; sectorTags: string[]; privacyNoticeText: string; privacyNoticeVersion: string }
export const barangaySettings = { queryKey: ['barangay'], queryFn: () => api<BarangaySettings & { name: string }>('/barangay') };
